(function(){
  var ship=document.querySelector('[data-fcb-ship]'), reco=document.querySelector('[data-fcb-reco]');
  if(!ship&&!reco)return;
  var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
  function money(c){try{return (c/100).toLocaleString('fr-FR',{style:'currency',currency:(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'EUR'});}catch(e){return (c/100).toFixed(2).replace('.',',')+' €';}}
  function getCart(){return fetch(root+'cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();});}

  /* ---------- barre livraison offerte ---------- */
  function updShip(cart){
    if(!ship)return;
    var free=parseInt(ship.getAttribute('data-free'),10)||8000, min=parseInt(ship.getAttribute('data-min'),10)||0;
    var t=cart.total_price, box=ship.querySelector('[data-fcb-box]'), msg=ship.querySelector('[data-fcb-msg]'), bar=ship.querySelector('[data-fcb-bar]');
    ship.classList.toggle('is-empty',cart.item_count===0);
    var c=ship.querySelector('[data-fcb-count]');if(c)c.textContent=cart.item_count>0?'('+cart.item_count+')':'';
    var state,pct,html;
    if(t<min){state='min';pct=t/min*100;html='Encore <b>'+money(min-t)+'</b> pour atteindre le minimum de commande ('+money(min).replace(',00','')+').';}
    else if(t<free){state='progress';pct=t/free*100;html='Plus que <b>'+money(free-t)+'</b> pour profiter de la <b>livraison offerte</b>.';}
    else{state='done';pct=100;html='Bravo ! Votre <b>livraison est offerte</b>.';}
    box.className='fcb-ship is-'+state;msg.innerHTML=html;bar.style.width=Math.min(100,Math.max(3,pct))+'%';
  }

  /* ---------- récapitulatif (total) ---------- */
  function refreshFooter(){
    var f=document.getElementById('main-cart-footer');if(!f)return;
    var id=f.getAttribute('data-id');if(!id)return;
    fetch(root+'cart?section_id='+encodeURIComponent(id)).then(function(r){return r.text();}).then(function(h){
      var d=new DOMParser().parseFromString(h,'text/html');var src=d.getElementById('main-cart-footer');if(!src)return;
      f.className=src.className;var a=f.querySelector('.js-contents'),b=src.querySelector('.js-contents');if(a&&b)a.innerHTML=b.innerHTML;
      var btn=document.getElementById('checkout');if(btn)btn.disabled=src.classList.contains('is-empty');
    });
  }

  /* ---------- recommandations ---------- */
  var rail=reco&&reco.querySelector('[data-fcb-rail]'), lastPid=null;
  function filterRail(cart){
    if(!rail)return;var ids={};cart.items.forEach(function(i){ids[i.product_id]=1;});
    [].forEach.call(rail.querySelectorAll('[data-pid]'),function(el){el.hidden=!!ids[el.getAttribute('data-pid')];});
    reco.hidden=!rail.querySelector('[data-pid]:not([hidden])');
  }
  function loadReco(cart){
    if(!rail||!cart.items.length)return;
    var pid=cart.items[0].product_id;if(pid===lastPid)return;lastPid=pid;
    var limit=parseInt(reco.getAttribute('data-limit'),10)||10;
    function get(intent){return fetch(root+'recommendations/products?product_id='+pid+'&limit='+(limit+6)+'&section_id=flivo-cart-reco&intent='+intent).then(function(r){return r.ok?r.text():'';});}
    get('complementary').then(function(h){
      var d=new DOMParser().parseFromString(h||'','text/html');var items=d.querySelectorAll('[data-pid]');
      if(items.length>=3)return d;return get('related').then(function(h2){return new DOMParser().parseFromString(h2||'','text/html');});
    }).then(function(d){
      var ids={};cart.items.forEach(function(i){ids[i.product_id]=1;});
      var fresh=[].filter.call(d.querySelectorAll('[data-pid]'),function(el){return !ids[el.getAttribute('data-pid')];});
      if(fresh.length<3)return;
      var seen={};fresh=fresh.filter(function(el){var p=el.getAttribute('data-pid');if(seen[p])return false;seen[p]=1;return true;}).slice(0,limit);
      var old=[].filter.call(rail.querySelectorAll('[data-pid]'),function(el){return !seen[el.getAttribute('data-pid')];});
      rail.innerHTML='';rail.scrollLeft=0;fresh.forEach(function(el){rail.appendChild(document.importNode(el,true));});
      old.slice(0,Math.max(0,limit-fresh.length)).forEach(function(el){rail.appendChild(el);});
      filterRail(cart);
    }).catch(function(){});
  }
  if(reco){reco.querySelectorAll('.fcb-arrow').forEach(function(a){a.addEventListener('click',function(){rail.scrollBy({left:(+a.getAttribute('data-dir'))*Math.max(rail.clientWidth*0.8,200),behavior:'smooth'});});});}

  function refresh(fromOther){getCart().then(function(c){updShip(c);filterRail(c);loadReco(c);if(fromOther)refreshFooter();});}
  var hasPS=(typeof subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined');
  if(hasPS){subscribe(PUB_SUB_EVENTS.cartUpdate,function(e){if(e&&e.source==='cart-items')refresh(false);});}
  /* ajouts faits par les boutons Flivo (suggestions, fiches) : on rafraîchit aussi la liste des articles */
  document.addEventListener('cart:refresh',function(){
    var ci=document.querySelector('cart-items');if(ci&&typeof ci.onCartUpdate==='function'){try{ci.onCartUpdate();}catch(e){}}
    refresh(true);
  });
  refresh(false);
})();
